/**
 * Generate initials from name or email
 * @param {string} nameOrEmail - User name or email
 * @returns {string} - Up to 2 initials
 */
export function getInitials(nameOrEmail) {
  if (!nameOrEmail) return '??';

  // If it looks like an email, use first letter before @
  if (nameOrEmail.includes('@')) {
    return nameOrEmail[0].toUpperCase();
  }

  // Split by spaces and get first letter of first two words
  const parts = nameOrEmail.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }

  return (parts[0][0] + parts[1][0]).toUpperCase();
}
